import Image from 'next/image';
const LocalImage = ({ url, className, unoptimize = true, alt }: any) => {
  return (
    <div className={`banner relative flex items-center justify-center ${className}`}>
      <div className="banner-media absolute top-0 bottom-0 w-full">
        <Image
          src={url}
          alt={alt ? alt : 'Banner'}
          loading="eager"
          fill
          quality={100}
          sizes="10%"
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
          }}
          unoptimized={unoptimize}
        ></Image>
      </div>
    </div>
  );
};

export default LocalImage;